var map = {
	"./BN-explanations.png": 7529,
	"./BN-game.png": 8062,
	"./BN-ship_placement.mp4": 549,
	"./BN-shooting_ship.mp4": 3093,
	"./BN-wrong_ship_placement.mp4": 1413,
	"./dachshund.gif": 7769,
	"./dachshund2.gif": 7787,
	"./default.gif": 1265,
	"./dogjammer.mp4": 281,
	"./ebullixir-cut_watermelon.mp4": 1983,
	"./ebullixir-failed_elixir.mp4": 7108,
	"./ebullixir-home_run.mp4": 4553,
	"./ebullixir-recipie_and_client.mp4": 7960,
	"./ebullixir-showup.mp4": 6787,
	"./ebullixir-spider_and_client.mp4": 5340,
	"./ebullixir-success_elixir.mp4": 9451,
	"./opensilex_accounts.png": 8705,
	"./opensilex_connexion.png": 8291,
	"./opensilex_logo.png": 927,
	"./pathfinder-main.png": 4746,
	"./patternrun-beginning.mp4": 6111,
	"./patternrun-double_jump.mp4": 2360,
	"./patternrun-gameover.png": 1877,
	"./patternrun-jetpack.png": 2618,
	"./patternrun-movement_strategy.png": 9694,
	"./patterns_students_projects.png": 2262,
	"./personaljsframework.png": 6641,
	"./plush-main.mp4": 9282,
	"./plush-tap.mp4": 9153,
	"./plush-travelling_room.mp4": 7381,
	"./plush-warehouse_poster.png": 5753,
	"./poorsausage-ax.gif": 3575,
	"./poorsausage-bullet.mp4": 9688,
	"./poorsausage-demo.mp4": 3328,
	"./poorsausage-laser.mp4": 1652,
	"./poorsausage-menu.mp4": 9094,
	"./poorsausage.mp4": 6729,
	"./submarine-collecting_seaweed.mp4": 3037,
	"./submarine-main.mp4": 3352,
	"./submarine-red_panda.mp4": 9400,
	"./submarine-submarine_travel.mp4": 7365,
	"./tuto1.mp4": 1371,
	"./tuto1.png": 2585,
	"./tuto2.mp4": 5224,
	"./tuto2.png": 9964,
	"./whatsinpic-daschund-and-bike.mp4": 8920,
	"./whatsinpic-lynx.mp4": 8493,
	"./whatsinpic-main.png": 6841,
	"./xraychest-data_distribution.png": 6457,
	"./xraychest-image_modif.png": 8659,
	"./xraychest-learning_curve.png": 1326,
	"./xraychest-main.png": 6501,
	"./xraychest-matrice_confusion1.png": 3618,
	"./xraychest-matrice_confusion2.png": 4366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1805;